import React, {useState} from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import {
    IconButton, PlusIcon, FormField, TextField,
} from 'components/controls';

import commonStyles from 'styles/common.scss';
import StringArrayItem from './StringArrayItem';

function StringArrayFormField(props) {
    const {
        label,
        labelNote,
        className,
        error,
        value,
        onChange,
    } = props;

    const [text, setText] = useState('');

    const handleTextChange = (e) => {
        setText(e.target.value);
    };

    const handleAdd = () => {
        onChange({target: {value: [...value, text]}});
        setText('');
    };

    const handleDelete = (e, index) => {
        e.preventDefault();
        onChange({
            target: {
                value: value.filter((o, i) => i !== index),
            },
        });
    };

    const formClassName = classnames(commonStyles.relative, className);
    return (
        <FormField
            label={label}
            labelNote={labelNote}
            className={formClassName}
            error={error}
        >
            <TextField
                error={error}
                onChange={handleTextChange}
                value={text}
            >
                <IconButton
                    onClick={handleAdd}
                    isAdornment
                >
                    <PlusIcon />
                </IconButton>
            </TextField>
            {value.map((o, index) => (
                <StringArrayItem
                    value={o}
                    index={index}
                    onDelete={handleDelete}
                />
            ))}
        </FormField>
    );
}

StringArrayFormField.propTypes = {
    label: PropTypes.string,
    labelNote: PropTypes.string,
    className: PropTypes.string,
    error: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
};

StringArrayFormField.defaultProps = {
    label: '',
    labelNote: '',
    className: '',
    error: '',
    value: '',
};

export default StringArrayFormField;



// WEBPACK FOOTER //
// ./src/components/controls/form/StringArrayFormField/StringArrayFormField.jsx